import Vue from 'vue'
import {
  Button, Form, FormItem, Input, Container, Header, Aside, Main,
  Menu, Submenu, MenuItemGroup, MenuItem,
  Breadcrumb, BreadcrumbItem,
  Card,
  Row, Col,
  Table, TableColumn,
  Switch,
  Tooltip,
  Pagination,
  Dialog,
  MessageBox,
  Message,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Transfer,
  Tabs,
  TabPane,
  Upload,
  Tag,
  Steps,
  Step,
  Select,
  Option,
  DatePicker,
  Avatar,
  Divider,
  Radio,
  Collapse,
  CollapseItem,
  Link,
  InputNumber,
  Image
} from 'element-ui'
import VueCropper from 'vue-cropper'

Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItemGroup)
Vue.use(MenuItem)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Switch)
Vue.use(Tooltip)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Transfer)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Upload)
Vue.use(Tag)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(Avatar)
Vue.use(Divider)
Vue.use(Radio)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Link)
Vue.use(DatePicker)
Vue.use(InputNumber)
Vue.use(Image)
Vue.use(VueCropper)

Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
